export const TranslationsSV = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: 'Beställ online',
        cart: 'Varukorg',
        open_24: '24 timmar',
        closed: 'Stängt',
        free: 'gratis',
        something_went_wrong: 'Ett fel har inte träffat',
        try_again: 'försök igen',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Måndag',
                tuesday: 'Tisdag',
                wednesday: 'Onsdag',
                thursday: 'Torsdag',
                friday: 'Fredag',
                saturday: 'Lördag',
                sunday: 'Söndag',
            },
        },
        services: {
            pickup: 'Avhämtning',
            delivery: 'Utkörning',
            dine_in: 'Dine-In (ät på plats)',
            table_booking: 'Bordsbokning',
        },
        payment: {
            method: {
                cash: 'Kontant',
                card: 'Kort',
                stripe: 'Kreditkort',
                paypal: 'PayPal',
                cardconnect: 'Kreditkort',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Kontant',
                card: 'Kort',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
            },
            status: {
                success: 'Lyckad',
                pending: 'I väntan på',
                error: 'Felmeddelande',
                refunded: 'Återbetalning',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Ta bort',
                drop_here: 'Ladda upp dina filer här eller tryck här för att välja en',
                accepts: 'Acceptera {{fileTypes}} filer',
                errors: {
                    max_files: 'Maximalt {{number}} tillåtna',
                    max_size: 'Max filstorlek {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'Butiken är för närvarande stängd och det är ej möjligt att göra en ”dine- in” beställning för tillfället. Du är välkommen att göra ett försök en annan dag vid ett annat tillfälle.',
            },
            buttons: {
                order: {
                    book_order: 'Boka bord / Beställ online',
                    order_online: 'Beställ online',
                    book_table: 'Boka ett bord',
                    order: 'Beställning',
                    book: 'Boka',
                    cart: 'Varukorg',
                    restart: 'Börja om',
                    closed: 'Butiken är stängt',
                    not_accepting: 'Vi tar ej emot beställningar',
                },
            },
        },
        modals: {
            auth: {
                login: 'Logga in',
                register: 'Registrera',
                register_commence: 'Fortsätt',
                register_complete: 'Skapa konto',
                register_confirmation_sent: 'En bekräftelsekod har skickats till din e-postadress. Vänligen ange den nedan för att fortsättaeed',
                register_confirmation_resent: 'Bekräftelsekoden har skickats igen, kontrollera din skräppost eller starta om processen',
                register_restart: 'Börja om',
                register_resend_code: 'Skicka kod igen',
                register_confirmation_code_subject: 'E-Mail bekräftelse kod',
                register_confirmation_code_email: 'Din e-postbekräftelsekod är {{confirmation_code}} (tillgänglig i 24 timmar)',
                login_placeholder: 'E-mail',
                password_placeholder: 'Lösenord',
                confirm_password_placeholder: 'Bekräfta lösenord',
                confirmation_code_placeholder: 'E-Mail bekräftelse kod',
                accept_terms: 'Godkänna regler och villkor',
                accept_terms_view: 'granska',
                login_facebook: 'Logga in via Facebook',
                login_google: 'Logga in via Google',
                benefits: 'Logga in eller skapa ett konto för att spara alla dina beställningar',
                logged_in: 'Inloggning lyckades',
                logged_out: 'Logga ut',
                password_reset: {
                    init_button: 'Skicka lösenord till e-postadress',
                    init_success: 'Lösenordsåterställningslänk har skickats till din e-post',
                    complete_button: 'Reset Password',
                    complete_success: 'Password successfully reset, login with your new password',
                    forgot_password_text: 'Forgotten your password? ',
                    forgot_password_link: 'Återställ lösenord',
                    remember_password_text: 'Har du glömt ditt lösenord?',
                    remember_password_link: 'Gå tillbaka',
                    invalid_title: 'Lösenordsåterställning ogiltigt',
                    invalid_description: 'Denna länk för återställning av lösenord är inte giltig, begär en ny istället',
                    invalid_link: 'Gå till Inloggning',
                    title: 'Återställning av lösenord',
                    description: 'Ange ett nytt lösenord för ditt konto',
                },
                error_generic: 'Något fel inträffade, försök igen eller kontakta oss',
                error_accept_terms: 'Vänligen acceptera villkoren',
                error_password_length: 'Minst 6 tecken för lösenord',
                error_social: 'Något fel inträffade, försök igen eller kontakta oss',
                error_confirmation_code: 'ogiltig bekräftelsekod',
                error_invalid_code: 'ogiltig bekräftelsekod',
                error_exists: 'Användaren finns redan',
                error_invalid_email_pass: 'Ogiltig e-mailadress eller lösenord',
                error_password_no_match: 'Lösenord matchar inte varandra',
                error_user_not_found: 'Ingen användare med den e-postadressen',
                error_invalid_email: 'Ogiltig e-postadress',
                error_invalid_reset_token: 'Ogiltig återställningslänk, begär en annan',
            },
            booking: {
                form: {
                    name: 'Fullständiga namn',
                    email: 'E-postadress',
                    phone: 'Telefonnummer',
                    number_of_people: 'Antal personer',
                    number_of_people_max: 'Antal personer ({{max_people}} Max)',
                    number_of_people_min: 'Antal personer ({{min_people}} Min)',
                    number_of_people_max_min: 'Antal personer (Mellan {{min_people}} till {{max_people}})',
                    notes: 'Anteckningar/Särskilda önskemål',
                    submit: 'Skicka bokningsförfrågan',
                    email_optional: '(valfritt)',
                    date: 'Datum',
                    duration: 'Varaktighet',
                    seating: 'Tillgängliga tider',
                    number_of_guests: 'Antal gäster',
                    notes_placeholder: 'Allergier, tillfälle, platsönskemål',
                    reserving: 'Reserverar...',
                    reserve_table: 'Boka bord',
                    please_choose_a_date_and_time: 'Välj ett datum och en tid.',
                    invalid_people: 'Antalet personer måste vara mellan {{min}} och {{max}}.',
                    party_size_max_fallback: 'det tillåtna maxantalet',
                    loading_available_times: 'Laddar tillgängliga tider…',
                    select_a_date_to_see_available_times: 'Välj ett datum för att se tillgängliga tider.',
                    no_times_available_for_this_date: 'Inga tider tillgängliga för detta datum. Välj en annan dag.',
                    shift: 'Pass',
                    service_times: 'Servicetider',
                    new_shift: 'Nytt pass',
                    time: 'tid',
                    times: 'tider',
                    unavailable: 'Inte tillgänglig',
                    available: 'Tillgänglig',
                    required_name: 'Ange ditt namn.',
                    required_phone: 'Ange ditt telefonnummer.',
                    required_email: 'Ange din e-postadress.',
                    invalid_email: 'Ange en giltig e-postadress.',
                    required_terms: 'Godkänn villkoren innan du bokar.',
                    reservation_is_unavailable: 'Bokning är inte tillgänglig.',
                    please_contact_the_restaurant_directly: 'Kontakta restaurangen direkt.',
                    almost_done: 'Nästan klart',
                    your_details: 'Dina uppgifter',
                    tell_us_who_s_coming: 'Berätta vem som kommer så att vi kan bekräfta din bokning.',
                    book_your_table: 'Boka ditt bord',
                    choose_a_time_that_works_for_you: 'Välj en tid som passar dig.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Skicka din bokningsförfrågan så tar restaurangen hand om resten.',
                    select_date: 'Välj datum',
                    standard: 'Standard',
                    minutes: 'minuter',
                    next: 'Nästa →',
                    back: '← Tillbaka',
                    accept_terms: 'Jag godkänner villkoren.',
                    info_1: 'Du kommer att få ett e-postmeddelande när din bokning accepteras eller nekas',
                },
                errors: {
                    not_found: 'Bokning finns inte. Den är möjligen raderad',
                    booking_not_found: 'Bokningen finns inte. Den kan ha tagits bort',
                    generic: 'Ett fel inträffade, uppdatera sidan eller kontakta oss',
                    something_went_wrong: 'Something went wrong',
                    accept_terms: 'Ett fel inträffade',
                    required_phone: 'Vänligen skriv in ditt telefonnummer',
                    required_email: 'Vänligen ange din e-postadress',
                    required_zip: 'Ange ditt faktureringspostnummer',
                    required_name: 'Vänligen fyll i ditt namn',
                    invalid_email: 'Vänligen ange en giltig e-postadress',
                    invalid_phone: 'var vänlig och ange ett giltigt telefonnummer',
                    invalid_people: 'Ogiltigt antal personer',
                    missing_custom_fields: 'Vänligen fyll i alla obligatoriska fält.',
                    booking_capacity_threshold: 'Vi är fullbokade för den här tiden. Prova en annan tid.',
                    slot_unavailable: 'Vi är fullbokade för det här antalet personer. Prova en annan tid.',
                    booking_date_paused: 'Bokningar är pausade för det här datumet. Välj en annan dag.',
                    invalid_table_assignment: 'De borden rymmer inte ditt sällskap. Välj en annan tid.',
                    exceeded_order_limit: 'För många bokningsförfrågningar. Försök igen senare.',
                    validation_failed_recaptcha_v3: 'Ovanlig trafik upptäcktes. Använder du VPN? Slutför verifieringen ovan och försök igen.',
                    validation_failed_recaptcha_v2: 'Bokningen kunde inte påbörjas. Försök igen eller använd en annan metod. Om du använder VPN, prova att stänga av det först.',
                    booking_already_exists: 'Den här bokningen har redan skickats. Kontrollera din e-post eller öppna din bokningslänk.',
                    invalid_party_size: 'Välj ett giltigt antal personer.',
                    invalid_request: 'Ogiltig begäran. Uppdatera sidan och försök igen.',
                    table_booking_unavailable: 'Bordsbokning är inte tillgänglig.',
                },
            },
            cart: {
                title: 'Varukorg',
                proceed_to_checkout: 'Fortsätt till utcheckningen',
                edit_dish: 'Redigera',
                remove_dish: 'Ta bort',
                no_items_1: 'Inga varor i varukorgen',
                no_items_2: 'Lägg till varor varukorgen för att fortsätta',
                free_delivery_notice: 'Fri leverans för beställningar över {{value, currency}}',
                errors: {
                    min_order_promo: 'Minsta varukorgsvärde på {{value, currency}} krävs för att ta del av detta erbjudande',
                    min_order_delivery: 'Minsta kundvagnsvärde på {{value, currency}} för leverans',
                },
                promo: {
                    heading: 'Rabattkod',
                    placeholder: 'Knappa in din rabattkod',
                    add: 'Lägg till kod',
                    title: 'Kampanj {{name}} lagts till i kundvagnen',
                    fixed_discount: '{{value, currency}} Off',
                    percent_discount: '{{value}}% Off',
                    added_to_cart: 'Kampanj har lagts till i kundvagnen',
                    errors: {
                        not_found: 'Kampanjen hittades inte',
                        disabled: 'Kampanjen är inaktiverad',
                        not_available: 'Kampanjen är för närvarande inte tillgänglig',
                        not_eligible: 'Ej kvalificerad att använda kampanjkod',
                        logged_in_only: 'Måste vara inloggad för att använda denna kampanj',
                        already_used: 'Du har redan använt denna kampanj',
                        invalid: 'Denna kampanj är inte längre giltig',
                        invalid_service: 'Denna kampanj är inte giltig för din valda tjänst',
                        later_only: 'Gäller endast för förbeställningar',
                        now_only: 'Gäller endast för omedelbara beställningar, ej förbeställning',
                        generic: 'Hoppsan... något gick fel och har loggats',
                        dishes_required_multi: 'Denna kampanj kommer endast att tillämpas när vissa varor läggs till i din varukorg',
                        dishes_required_single: "Denna kampanj kommer endast att ansökas om '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Dricks',
                    placeholder: 'Lägg till dricks',
                },
            },
            free_items_promo: {
                title: 'Kostnadsfria artiklar',
                usage_confirmation: {
                    question: 'Du är berättigad till kostnadsfria artiklar. Vill du se och lägga till dem?',
                    cancellation: 'Nej, jag vill inte ha kostnadsfria artiklar',
                    acceptance: 'Ja',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Välj {{number}} kostnadsfria artik(lar)',
                    },
                    single: {
                        description: 'Välj en kostnadsfri artikel',
                    },
                    confirm_button: 'Bekräfta',
                },
            },
            checkout: {
                title: 'Utcheckning',
                subtitle: 'Bekräfta dina beställningsuppgifter',
                details: {
                    service: 'Service',
                    due: 'Due',
                    due_now_asap: 'Now / ASAP',
                    address: 'Leveransadress',
                    total: 'Totalt',
                    table: 'Bord',
                    store_location: 'Butiks adress',
                },
                customer: {
                    title: 'Kund',
                    subtitle: 'Logga in för att spara din beställning och info',
                    button: 'Logga in',
                    name: 'Fullständiga namn',
                    email: 'E-postadress',
                    phone: 'Telefonnummer',
                    phone_important: 'Telefonnummer (Obligatoriskt)',
                    notes: 'Beställningsanteckningar',
                    delivery_notes: 'Leveransinstruktioner/Beställningsanteckningar',
                    optional: 'Frivilligt',
                },
                payment: {
                    title: 'Betalningsmetod',
                    qr_modal_help: "Använd din {{app}}-mobilapplikation för att skanna QR koden och fyll i betalning för denna beställning.  När betalningen genomförd på din mobilapplikation kan du stänga ner QR fönstret .Vänligen stäng inte detta QR- fönster om du inte har avslutat din betalning.",
                    switch_to_app_help: "Genom att trycka på knappen nedan öppnas {{app}} mobilapplikation automatiskt för att slutföra betalningen för denna beställning.  När du slutfört betalningen på din mobilapplikation kan du stänga ner fönstret. Stäng inte ner fönstret om du inte har slutfört din betalning.",
                    open_app: 'Öppna {{app}}-appen'
                },
                accept_terms: 'Godkänna regler och villkor',
                accept_terms_view: 'Granska',
                processing_order: 'Bearbetar order',
                warning: {
                    different_payment_currency: 'Butikspriserna är i {{store_currency}} men betalningsmetoden är i {{payment_currency}}',
                    closing_soon: 'Stängs snart, beställningar måste göras inom {{value}} minuter',
                    closed: 'Tyvärr, denna tjänst har stängt och beställningar accepteras inte',
                    expired: 'Vi kan inte längre fullfölja din beställning vid den tid du valt. Välj ett senare datum eller tid',
                },
                errors: {
                    stripe_generic: 'Kreditkortsfel, försök igen eller någon annan metod',
                    stripe_loading_fail: 'Det gick inte att läsa in betalningsformuläret, försök igen',
                    something_went_wrong: 'Ett fel inträffade',
                    paypal_generic: 'Ett fel inträffade med PayPal, försök igen eller välj en annan betalningsmetod',
                    payment_fail: 'Betalningen misslyckades, försök igen eller välj en annan betalningsmetod',
                    payment_cancelled: 'Betalningen avbruten, försök igen eller välj en annan betalningsmetod',
                    payment_error: 'Det gick inte att behandla onlinebetalningen, försök igen eller välj en annan betalningsmetod',
                    payment_declined: 'Ditt betalningssätt accepterades inte',
                    card_declined: 'Ditt kort avvisades och betalningen kunde inte genomföras',
                    promo_max_uses_exceeded: "Den här kampanjkoden har nått sin användningsgräns och är inte längre tillgänglig.",
                    store_closed: 'Butiken är stängd och tar inte längre emot beställningar',
                    accept_terms: 'Vänligen acceptera villkoren',
                    required_payment: 'Välj en betalningsmetod',
                    required_phone: 'Vänligen skriv in ditt telefonnummer',
                    required_email: 'Vänligen ange din e-postadress',
                    required_zip: 'Ange ditt postnummer',
                    required_name: 'Vänligen fyll i ditt namn',
                    invalid_email: 'Vänligen ange en giltig e-postadress',
                    invalid_phone: 'Var vänlig och slå in ett giltigt telefonnummer',
                    invalid_cc_number: 'Ditt kreditkortsnummer är ogiltigt',
                    invalid_order_amount: 'Minsta belopp som krävs för denna betalningsmetod',
                    retry_cc_number: 'Något gick fel, ange ditt kreditkortsnummer igen och försök igen',
                    closed: 'Butiken är stängd/stänger och tar inte emot beställningar',
                    promo_login_required: 'Du måste vara inloggad för att använda denna kampanj',
                    promo_used: 'Du har redan använt denna kampanj',
                    promo_by_payment_method_not_applicable: 'Kampanjen är inte tillämplig på den valda betalningsmetoden.',
                    missing_custom_checkout_fields: 'Vänligen fyll i alla obligatoriska fält.',
                    delivery_unavailable: 'Leveranstjänsten kanske inte är tillgänglig just nu. Vänligen överväg att göra en hämtningsorder istället.',
                    required_delivery_provider: 'Välj en tjänsteleverans.',
                },
                button: {
                    continue: 'Fortsätt till betalning',
                    place_order: 'Beställa',
                },
                delivery_estimation: {
                    title: 'Leveransuppskattning',
                    details: {
                        provider: 'Leveransleverantör',
                        estimated_fee: 'Beräknad avgift',
                        estimated_delivery_time: 'Beräknad leveranstid',
                        tips: 'Tips',
                    },
                    quotation_error: 'Något gick fel vid beräkning av leveransuppskattning.',
                },
            },
            customer: {
                age_v: {
                    title: 'Åldersverifiering',
                    required_for_items: 'Krävs för att beställa vissa varor',
                    min_age: 'Minimiålder: {{age}} år',
                    est_time: 'Beräknad verifieringstid: {{time}} timmar',
                    upload_description: 'Ladda upp ditt ID nedan för verifiering. Du kommer att meddelas via e-post när den har verifierats. Ladda upp upp till 2 bilder med en maximal storlek på 2 MB vardera',
                    pending_description_1: 'Tack för att du skickade in dina dokument. Du kommer att meddelas via e-post när du är godkänd',
                    pending_description_2: 'Uppdatera sidan för att uppdatera din verifieringsstatus. Beräknad verifieringstid är {{time}} timmar',
                    approved_description: 'Ditt konto har verifierats och du kan beställa från begränsade menyer',
                    rejected_description: 'Ditt ID har avvisats. Om du vill försöka igen, ladda upp ditt ID igen',
                    upload: 'Ladda upp',
                    reupload: 'Ladda upp dokumenten igen',
                    go_back: 'Gå tillbaka',
                    view_document: 'Visa dokument {{number}}',
                    status: {
                        unverified: 'Ej verifierad',
                        pending: 'Väntar på godkännande',
                        approved: 'Verifieringen lyckades',
                        rejected: 'Avvisad',
                    },
                },
                headings: {
                    sessions: 'Sessioner',
                    orders: 'Beställningar',
                    spend: 'Spenderat',
                    order_history: 'Beställningshistorik',
                    loyalty_points: 'Lojalitetspoäng',
                },
            },
            custom_payment: {
                title: '{{name}} Betalningsformulär',
                description: 'Du har nått vårt onlinebetalningsformulär. Fyll i fälten nedan för att göra en betalning. Om ett belopp inte skrivs in kommer dina uppgifter att sparas men du kommer inte att debiteras.',
                disabled: 'Denna onlinebetalningssida har inte konfigurerats korrekt. Kontakta webbplatsens ägare för att åtgärda problemet.',
                success: 'Din betalning har behandlats och dina uppgifter har sparats. Tack',
                back: 'Tillbaka till startsida',
                fields: {
                    name: 'Fullständiga namn',
                    email: 'E-postadress',
                    reference: 'Betalning Ref.',
                    amount: 'Belopp ($)',
                    name_on_card: 'Kortinnehavare',
                    submit: 'Gör en betalning',
                },
                warning: {
                    currency: 'Obs! Betalningsbelopp i {{actual}}, inte {{default}}',
                },
                errors: {
                    generic: 'Ett fel inträffade, försök igen eller kontakta oss',
                    stripe_generic: 'Kreditkortsfel, uppdatera sidan och försök igen',
                    payment_fail: 'Betalningen misslyckades, försök igen eller välj en annan betalningsmetod',
                    payment_cancelled: 'Betalningen avbruten, försök igen eller välj en annan betalningsmetod',
                    payment_error: 'Det gick inte att bearbeta onlinebetalning, försök igen eller välj en annan betalningsmetod',
                    payment_declined: 'Din betalningsmetod nekades',
                    card_declined: 'Ditt kort avvisades och betalningen kunde inte behandlas',
                    promo_max_uses_exceeded: "Den här kampanjkoden har nått sin användningsgräns och är inte längre tillgänglig.",
                },
            },
            dish: {
                add: 'Lägg till i varukorgen',
                edit: 'Uppdatera artikeln',
                notes: 'Särskilda instruktioner...',
                ingredients: {
                    title: 'Ingredienser',
                    uncheck_remove: 'Avmarkera för att ta bort',
                },
                ingredients_title: 'Ingredienser',
                combo: {
                    choose_dish: 'Välj en artikel',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Välj en (obligatorisk)',
                        select_one_optional: 'Välj en (valfritt)',
                        select_between: 'Välj mellan {{min}} - {{max}} (obligatoriskt)',
                        select_at_least: 'Välj minst {{qty}} (obligatoriskt)',
                        select_up_to: 'Välj upp till {{qty}} (valfritt)',
                        select_multiple: 'Välj flera (valfritt)',
                        free_amount: 'Första {{qty}} gratis / {{selected}} valt',
                    },
                    points: {
                        none_consumed: 'Du kan välja maximalt {{maxFree}} alternativ kostnadsfri',
                        less_than_total_points: 'Du kan välja flera alternativ kostnadsfritt',
                        greather_than_total_points: 'Du kan välja fler alternativ för extra avgifter',
                    },
                },
                error: 'Vänligen korrigera eventuella alternativ markerade med rött',
                added_to_cart: 'Artikel tillagd i varukorgen',
            },
            map: {
                zone_fee: 'Leveranskostnad',
                view_in_google: 'Se i Google Maps',
            },
            portal_go_back: {
                title: 'Gå tillbaka till restaurangsökning?',
                description: 'Alla föremål i din varukorg kommer att gå förlorade',
                cancel: 'Avbryt',
                proceed: 'Gå tillbaka',
            },
            order: {
                config: {
                    services: {
                        title: 'Välj en tjänst',
                        table_booking: 'Boka bord',
                    },
                    address_custom: {
                        input_placeholder: 'Ange din adress',
                    },
                    address: {
                        input_placeholder: 'Hitta din leveransadress',
                        extras_placeholder: 'Enhetsnummer, byggnadens namn, leveransinstruktioner, etc...',
                        search_placeholder: 'Sök efter din adress',
                        search_input_placeholder: 'Skriv för att söka',
                        no_address_found: 'Inga adresser hittades',
                        not_found: 'Leveransadressen hittades inte eller är ej giltig, försök igen',
                        not_delivering: 'Vi levererar för närvarande inte till den här adressen',
                        not_in_range: 'Din adress är inte inom räckhåll för vår butiksplats',
                        not_in_zone: 'Din adress är inte inom en aktiv leveranszon',
                        no_number: 'Din adress måste ha ett gatunummer',
                        location_permission: 'Tillåt den här webbplatsen att komma åt din nuvarande plats?',
                        location_permission_warning: 'Kan inte komma åt din nuvarande plats. Vänligen aktivera platstjänsten på din enhet och webbläsare. Här är några referenser:',
                        pick_location: 'Välj din plats',
                        pick_location_help_text: 'Dra markören för att välja plats på kartan.',
                        use_current_location: 'Använd nuvarande plats',
                        locate_on_map: 'Lokalisera på kartan',
                    },
                    datetime: {
                        title: 'När skulle du vilja ha din beställning',
                        due_now: 'Nu',
                        due_later: 'Senare',
                        service_not_available: 'Tyvärr, vi tar för närvarande inte emot beställningar för {{service}}',
                        currently_closed: '{{service}} stängt för närvarande men du kan beställa för senare',
                        due_unavailable: 'Inte tillgänglig',
                        due_closed: 'Stängt',
                        select_date: 'Välj datum',
                        select_time: 'Välj tid',
                        select_order_date: 'Välj ditt beställningsdatum',
                        select_order_time: 'Välj din beställningstid',
                        select_booking_date: 'Välj bokningsdatum',
                        select_booking_time: 'Välj din bokningstid',
                        no_times_available: 'Inga tillgängliga tider att välja mellan',
                        date_today: '(I dag)',
                        date_closed: '(Stängt)',
                        date_bookings_paused: '(Bokningar pausade)',
                        time_slot_closed: 'Stängt',
                    },
                    number_of_people: {
                        placeholder: 'Antal personer',
                    },
                    table: {
                        select: 'Välj bord',
                        select_popup_title: 'Välj ditt bord',
                        password: 'Bordslösenord',
                        password_warning: 'Ange ditt bordslösenord för att fortsätta',
                    },
                    warning: {
                        closed: 'Tyvärr, vi har för närvarande stängt / vi tar inte emot några beställningar',
                        not_available: 'Tyvärr, vi tar för närvarande inte emot några beställningar',
                    },
                    eta: {
                        delivery: `Beräknad leveranstid är cirka {{minutesToCustomer}} minuter`,
                        pickup: `Beställningen kommer att vara redo om cirka {{minutesToCustomer}} minuter`,
                    },
                    start_button: 'Påbörja beställning',
                },
                history: {
                    invalid: 'Inte kvalificerad för ombeställning eftersom vissa av de beställda artiklarna har ändrats eller inte längre är tillgängliga',
                },
                reorder: {
                    title: 'Quick Re-Order',
                    description: 'Beställ enkelt artiklarna från dina tidigare beställningar',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Beställningen hittades inte, uppdatera sidan och försök igen',
                    generic: 'Ett fel uppstod, uppdatera sidan eller kontakta oss',
                },
                connection: {
                    connected: 'Realtidsuppdateringar',
                    connecting: 'Realtidsuppdateringar ansluts',
                    disconnected: 'Realtidsuppdateringar frånkopplade',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Varning',
                    title: 'Logga ut',
                    body: 'Om du loggar ut kommer alla artiklar som har lagts till i din varukorg att tas bort',
                    cancel: 'Avbryt',
                    proceed: 'Fortsätta',
                },
                order_restart: {
                    warning: 'Varning',
                    title: 'Ändra orderdetaljer',
                    body: 'Om du ändrar dina beställningsuppgifter kommer varorna i din varukorg att tas bort eftersom vissa varor kan bli otillgängliga',
                    cancel: 'Avbryt',
                    proceed: 'Fortsätta',
                },
                order_expired: {
                    subtitle: 'Viktigt',
                    title: 'Ordern ändrad för omedelbar beställning',
                    description: 'Den valda tiden för din beställning är nu inte långt kvar. Som sådan har din beställning ändrats till att förfalla omedelbart / ASAP',
                    button: 'Ok',
                },
                order_expiring: {
                    subtitle: 'Viktigt',
                    title: 'Beställningsdeadline löper ut snart',
                    description: 'Din beställning måste göras innan {{time, timeFromTimestamp}} annars är den inte längre giltig',
                    button: 'Ok',
                },
                location_permission: {
                    cancel: 'Avbryt',
                    proceed: 'Fortsätta',
                },
            },
            card_payment_authentication: {
                title: 'Autentisering av betalning',
                note: 'Vänligen håll det här fönstret öppet tills du slutför autentiseringsprocessen från din bank.',
            },
            maps: {
                cancel: 'Avbryt',
                use_location: 'Använd plats',
            },
        },
        sections: {
            nav_top: {
                guest: 'Gäst',
                login: 'Logga in',
                login_signup: 'Logga in / Bli medlem',
                logout: 'Logga ut',
            },
            menus: {
                info: {
                    no_menus: 'Det finns för tillfället inga menyer tillgängliga',
                    restrictions: 'Menybegränsningar',
                    not_available: 'Meny ej tillgänglig',
                    unavailable: {
                        times: 'Menyn inte tillgänglig, dina beställningskrav stämmer inte överens med nedan',
                        services: 'Meny ej tillgänglig, dina beställningskrav stämmer inte överens',
                        hours: 'Menyn är inte tillgänglig, dina beställningstider är inte tillgängliga inom denna meny',
                        pre_order: 'Menyn är inte tillgänglig, din beställning matchar inte kraven för förbeställning',
                        age: 'Menyn är inte tillgänglig, du måste vara inloggad med ett åldersverifierat konto för att kunna beställa från den här menyn',
                    },
                    services: {
                        title: 'Beställningskrav',
                        pickup: 'Avhämtningar',
                        delivery: 'Utkörningar',
                        dine_in: 'Dine-Ins (ät på plats)',
                    },
                    times: {
                        now: 'Inga förbeställningar',
                        later: 'Endast förbeställningar',
                    },
                    hours: {
                        title: 'Tillgängliga öppettider',
                    },
                    preorder: {
                        title: 'Krav för förbeställning',
                        days_in_advance: 'Måste beställas {{days}} dagar i förväg',
                        cutoff_time: 'Slutdatum stopptid kl. {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Åldersbegränsad',
                        approved: 'Ditt konto har verifierats och du kan beställa från denna meny',
                        rejected: 'Kräver åldersverifiering för att beställa. Skapa ett konto och ladda upp ditt legitimation',
                    },
                },
                search: {
                    title: 'Utforska menyalternativ',
                    no_result: 'Inget kom tillbaka. Försök med en annan sökterm?',
                    placeholder: 'Vad söker du?',
                },
            },
            category: {
                restrictions: 'Kategoribegränsningar',
                not_available: 'Kategori ej tillgänglig',
                unavailable: {
                    services: 'Kategori otillgänglig, dina beställningskrav stämmer inte överens med nedan',
                    hours: 'Kategori otillgänglig, dina beställningstider ligger inte inom denna kategoris tillgängliga tider',
                },
            },
            info: {
                location: {
                    title: 'Plats',
                    view_map: 'Visa karta',
                    phone: 'Telefon',
                },
                hours: {
                    title: 'Öppettider',
                    title_special: 'Särskilda öppettider',
                },
                services: {
                    title: 'Tjänster',
                    notes: 'Anteckningar',
                    delivery: {
                        ranges: 'Leveransomfång',
                        zones: 'Leveranszoner',
                        view_zones: 'Visa zoner på kartan',
                        fee: 'Leveransavgift',
                        fee_short: 'Avgift',
                        fee_varies: 'Varierar, visas i varukorgen',
                        min_order: 'Minsta beställning',
                        min_order_short: 'Min. best.',
                        no_min_order: 'Ingen minsta order',
                        free_amount: 'Kostnadsfritt leveransbelopp',
                    },
                },
            },
            contact: {
                title: 'Kontakta oss',
                name: 'Namn',
                email: 'E-post',
                phone: 'Telefonnummer',
                message: 'Skriv in ditt meddelande...',
                send: 'Skicka meddelande',
                success: 'Ditt meddelande har skickats',
                error: 'Ett fel uppstod, försök igen eller vid ett senare tillfälle',
            },
            footer: {
                powered_by: 'Powered By',
                terms_and_conditions: 'Regler & villkor',
                privacy: 'Integritetspolicy',
                cookie: 'Cookiepolicy',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Bokningskvitto',
            details: {
                datetime: 'Bokning för',
                number_of_people: 'Antal personer',
                placed: 'Placerad',
                updated: 'Senast uppdaterad',
                notes: 'Anteckningar',
                name: 'Namn',
                email: 'E-post',
                phone: 'Telefon',
                store_address: 'Butiksadress',
            },
            status_update: {
                title: 'Boknings {{number}} uppdaterad',
                body: 'Din bokningsstatus har uppdaterats till {{status}}',
            },
            email_common: {
                name: 'Namn: {{name}}',
                phone: 'Telefon: {{number}}',
                number_of_people: 'Antal personer: {{number}}',
                date: 'Datum: {{date}}',
                time: 'Tid: {{time}}',
                location: 'Butiksplats: {{name}}',
                notes: 'Anteckningar: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Ny bordsbokning {{number}} för {{name}}',
                powered_by: 'Powered By {{name}}',
                overview: 'Ny bordsbokningsförfrågan',
                title: 'Ny bokning för {{name}}',
                subtitle: 'Bokningsnummer {{number}}',
                description_confirmed: 'Bokningen har automatiskt bekräftats. Du kan avboka den via administratörspanelen och din kund kommer att meddelas via e-post',
                description_unconfirmed: 'Vänligen bekräfta eller avboka bokningen via administratörspanelen',
                url_pre_text: 'Visa och uppdatera på,',
            },
            email_new_booking_customer: {
                subject: 'Begäran om bordsbokning',
                powered_by: 'Powered By {{name}}',
                overview: 'Ny bordsbokningsförfrågan',
                title: 'Tack för din bokning',
                subtitle: 'Bokningsnummer {{number}}',
                description: '<b>Du kommer att få ett nytt e-postmeddelande när din bokning har bekräftats eller avvisats.</b><br>Kontakta oss för att göra eventuella ändringar i din bokning. Informationen om din bokning är följande:',
                url_pre_text: 'Du kan se ditt bokningskvitto i realtid på',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Bordsbokning har bekräftats',
                subject_unconfirmed: 'Bordsbokning avbokad',
                powered_by: 'Powered By {{name}}',
                overview: 'Begäran om bordsbokning',
                title_confirmed: 'Bokning bekräftad',
                title_unconfirmed: 'Bokning anullerad',
                subtitle: 'Bokningsnummer {{number}}',
                description_confirmed: 'Vi ser fram emot att se dig. Vänligen kontakta oss för att begära eventuella ändringar av din bokning',
                description_unconfirmed: 'Vi beklagar att informera dig om att din bokningsförfrågan inte kunde accepteras. Vi ber om ursäkt för eventuella besvär som orsakas. Kontakta oss om du har några frågor',
                url_pre_text: 'Du kan se ditt bokningskvitto i realtid på',
            },
            email_status_update_customer: {
                subject: 'Bokning #{{number}} – {{subjectLabel}}',
                body: 'Din bokning #{{number}} hos {{store}} är nu {{status}}.',
            },
            errors: {},
            status_warning: 'Uppdatera statusen för denna bokning i din administratörsöversikt på bokningssidan',
        },
    },
    email_delayed_order: {
        subject: 'Beställning #{{number}} – {{subjectLabel}}',
        header: 'Uppdaterad färdig tid',
        title: 'Uppdaterad färdig tid',
        order_number: 'Ordernummer: {{number}}',
        description: 'Din beställning är nu klar kl. {{time}}.',
        order_time_updated_to: 'Tiden för din beställning har uppdaterats.',
        powered_by: 'Drivs av {{name}}',
        button_text: 'Spåra beställning',
        subject_label: 'Uppdaterad färdig tid',
        subject_label_delivery: 'Uppdaterad leveranstid',
        body_ready: 'Din beställning är nu klar kl. {{time}}.',
        body_delivery: 'Din beställning levereras nu kl. {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Uppskattad Färdig tid',
            est_driver_pickup_time: 'Uppskattad Förarens hämtningstid',
            est_delivery_time: 'Uppskattad Leveranstid',
            tab_details: 'Detaljer',
            tab_dishes: 'Artiklar',
            future_order: 'Framtida beställningar',
            reprint: 'Skriv ut på nytt',
            details: {
                order_no: 'Beställningsnr.',
                status: 'Status',
                placed: 'Placerad',
                due: 'Due',
                due_asap: 'Nu / ASAP',
                last_updated: 'Senast uppdaterad',
                total: 'Total',
                type: 'Typ',
                table: 'Bord',
                number_of_people: 'Antal personer',
                payment_method: 'Betalningsmetod',
                payment_status: 'Betalningsstatus',
                payment_currency: 'Betalningsvaluta',
                notes: 'Anteckningar',
                name: 'Namn',
                email: 'E-post',
                phone: 'Telefon',
                distance: 'Avstånd',
                driving_time: 'Körtid',
                delivery_zone: 'Zon',
                delivery_address: 'Leveransadress',
                delivery_provider: 'Leveransleverantör',
                delivery_tracking: 'Leveransspårning',
                delivery_return_tracking: 'Track Return',
                delivery_tracking_link: 'Spåra beställning',
                tookan_status: 'Tookan Status',
                tookan_status_failed_book: 'Det gick inte att boka leverans',
                tookan_status_failed_update: 'Det gick inte att uppdatera bokningen',
                tookan_status_success: 'Bokad för leverans',
                store_address: 'Butiksadress',
            },
            dishes: {
                headings: {
                    quantity: 'Qty',
                    item: 'Artikel',
                    price: 'Pris',
                },
                notes: 'Anteckningar',
                remove_ingredients: 'Ta bort ingredienser',
            },
            status_update: {
                title: 'Beställning {{number}} uppdaterad',
                body: 'Din beställningsstatus har uppdaterats till {{status}}',
            },
            wait_time_update: {
                title: 'Beställning {{number}} uppdaterad',
                body: 'Din beställningstid har uppdaterats',
            },
            delivery_update: {
                title: 'Beställning {{number}} uppdaterad',
                body: 'Din beställning har bokats för leverans. Se länk för spårning i realtid',
            },
            payment_status_update: {
                title: 'Beställning {{number}} uppdaterad',
                body: 'Betalningsstatusen för din beställning har uppdaterats.',
            },
            email_new_order_restaurant: {
                subject: 'Ny beställning ({{number}}) - {{name}}',
                powered_by: 'Powered By {{name}}',
                overview: 'Avisering om ny beställning',
                title: 'Ny beställning gjord av {{name}}',
                subtitle: 'Beställningsnummer {{number}}',
                description: 'Se detaljer och uppdateringar via din administratörspanel',
                button_text: 'Track Order',
                track_delivery_button_text: 'Spåra leverans',
            },
            email_new_order_customer: {
                subject: 'Beställningskvitto ({{number}})',
                powered_by: 'Powered By {{name}}',
                overview: 'Avisering om ny beställning',
                title: 'Ny beställning gjord av {{name}}',
                subtitle: 'Beställningsnummer {{number}}',
                description: 'Se detaljer och uppdateringar via ditt realtidskvitto online',
                button_text: 'Track Order',
                track_delivery_button_text: 'Spåra leverans',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) inc. in price',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Leveransavgift',
            promo: 'Rabatt: {{name}} ({{value, currency}} + {{percent}}% Off)',
            promo_percent: 'Rabatt: {{name}} ({{percent}}%)',
            promo_fixed: 'Rabatt: {{name}}',
            promo_none: 'Rabatt: {{name}}',
            cart: 'Varukorg',
            tip: 'Dricks',
            total: 'Total',
        },
        status: {
            unconfirmed: 'Ej bekräftad',
            awaiting_payment: 'Inväntar betalning',
            confirmed: 'Bekräftat',
            ready: 'Redo',
            on_route: 'På väg',
            complete: 'Fullbordat',
            cancelled: 'Avbokad',
            seated: 'Placerad',
        },
        searching: {
            lalamove_search_placeholder: 'Sök beställning med Lalamove leverans-ID',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Ej tillgänglig',
                },
            },
            dish: {
                no_stock: 'Slutsåld',
                not_available: 'Ej tillgänglig',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'E-postbekräftelsekod',
            register_confirmation_code_email: 'Din e-postbekräftelsekod är {{confirmation_code}} (Upphör att gälla om 24 timmar)',
            register_confirmation_code_email_onbehalf: 'Din e-postbekräftelsekod är {{confirmation_code}} (Upphör att gälla om 24 timmar). Detta är för e-postadressen, {{email}}.',
        },
    },
};
//# sourceMappingURL=sv.js.map